import Container from "../../../utils/Container";
import loginImage from "../../../assets/banner/login.jpg";
import DhoorbinOutline from "../../../assets/icons/dhoorbin-outline.svg";
import BangladeshFlag from "../../../assets/icons/bangladesh.svg";
import { Link, useNavigate, useSearchParams } from "react-router";
import { useEffect } from "react";
import {
  authorizedToken,
  changePassword,
} from "../../../api/website/auth/auth";
import { useState } from "react";
import toast from "react-hot-toast";
const ResetPassword = () => {
  const navigate = useNavigate();
  const token = useSearchParams()[0].get("token");
  const [FormData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [IsLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (token) {
      authorizedToken(token, navigate);
    }
  }, [token]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = () => {
    if (!FormData.newPassword || !FormData.confirmPassword) {
      toast.error("Please fill all required fields");
    } else if (FormData.newPassword !== FormData.confirmPassword) {
      toast.error("Password does not match");
    } else {
      changePassword(FormData, token, navigate, setIsLoading);
    }
  };
  return (
    <Container>
      <div className="py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 p-0 lg:p-10">
          <div className="hidden lg:block w-[600px] h-[600px] overflow-hidden rounded-lg">
            <img
              className="w-full h-full object-cover"
              src={loginImage}
              alt=""
            />
          </div>
          <div className="flex flex-col items-center gap-y-3 p-0 lg:p-5">
            <div className="text-center py-8 relative">
              <p className="font-bold text-3xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Set New Password
              </p>
              <span className="text-sm text-black/50">
                Your World of Travel, Just One Click Away!
              </span>
              <div className="absolute -top-8 lg:-top-24 left-1/2 transform -translate-x-1/2 w-[200px] lg:w-[280px] opacity-60">
                <img className="" src={DhoorbinOutline} alt="" />
              </div>
            </div>
            <div className="w-full px-5 space-y-5">
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  New Password
                </label>
                <input
                  type="text"
                  placeholder="Enter your new password"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  id="newPassword"
                  value={FormData.newPassword}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Confirm Password
                </label>
                <input
                  type="text"
                  placeholder="Enter your confirm password"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  id="confirmPassword"
                  value={FormData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
              <div>
                <button
                  onClick={handleSubmit}
                  className="bg-[#153875] w-full py-3 rounded-lg text-white text-sm font-semibold scale-100 hover:scale-105 duration-300 active:scale-95"
                  disabled={IsLoading ? true : false}
                >
                  {IsLoading ? "Processing" : "Change Now"}
                </button>
              </div>
              {/* <div className="py-5 relative">
                <hr />
                <div className="absolute top-1/2 -translate-y-1/2 left-1/2 transform -translate-x-1/2 text-xs bg-[#ffffffb4] text-black/50 px-5 border py-0.5 rounded-md">
                  OR
                </div>
              </div>
              <div className="px-4">
                <button className="w-full border py-3 rounded-lg scale-100 hover:scale-105 duration-300 active:scale-95">
                  <div className="flex justify-center items-center gap-x-4">
                    <FaFacebook className="text-[#2155ad] text-lg" />
                    <p className="text-black/80 text-sm">Login With Facebook</p>
                  </div>
                </button>
              </div>
              <div className="px-4">
                <button className="w-full border py-3 rounded-lg scale-100 hover:scale-105 duration-300 active:scale-95">
                  <div className="flex justify-center items-center gap-x-4">
                    <FaGoogle className="text-[#ff002b] text-lg" />
                    <p className="text-black/80 text-sm">Login With Google</p>
                  </div>
                </button>
              </div> */}
              <div className="flex justify-center items-center">
                <Link to={"/authentication/signin"}>
                  <button className="text-[#2155ad] text-xs font-semibold cursor-pointer">
                    Do you have an account?
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ResetPassword;
